var watchlistPositionDelete = {
	title: "Positie verwijderen",
	caption: "Positie zal worden verwijderd",
	name: "Naam",
	alertHeading: "Weet u zeker dat u deze positie wilt verwijderen?",
	alertBody: "Zo ja, klik dan op ok. Houd er rekening mee dat verwijderde posities niet kunnen worden hersteld.",
	confirmBtn: "Ok",
	cancelBtn: "Annuleren"
};
var nl = {
	watchlistPositionDelete: watchlistPositionDelete
};

export { nl as default, watchlistPositionDelete };
